var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridArrowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    viewBox: "0 0 44 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 37,
    rx: 12,
    fill: "#4F4FD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.501 24.0432C12.501 22.1777 12.501 21.245 13.0815 20.6667C13.66 20.0864 14.5931 20.0864 16.4593 20.0864C18.3255 20.0864 19.2586 20.0864 19.8371 20.6667C20.4176 21.245 20.4176 22.1777 20.4176 24.0432C20.4176 25.9087 20.4176 26.8415 19.8371 27.4197C19.2586 28 18.3255 28 16.4593 28C14.5931 28 13.66 28 13.0815 27.4197C12.501 26.8425 12.501 25.9087 12.501 24.0432ZM23.5843 12.9568C23.5843 11.0913 23.5843 10.1585 24.1649 9.58033C24.7433 9 25.6764 9 27.5426 9C29.4089 9 30.342 9 30.9204 9.58033C31.501 10.1585 31.501 11.0913 31.501 12.9568C31.501 14.8223 31.501 15.755 30.9204 16.3333C30.342 16.9136 29.4089 16.9136 27.5426 16.9136C25.6764 16.9136 24.7433 16.9136 24.1649 16.3333C23.5843 15.755 23.5843 14.8223 23.5843 12.9568ZM23.5843 24.0432C23.5843 22.1777 23.5843 21.245 24.1649 20.6667C24.7433 20.0864 25.6764 20.0864 27.5426 20.0864C29.4089 20.0864 30.342 20.0864 30.9204 20.6667C31.501 21.245 31.501 22.1777 31.501 24.0432C31.501 25.9087 31.501 26.8415 30.9204 27.4197C30.342 28 29.4089 28 27.5426 28C25.6764 28 24.7433 28 24.1649 27.4197C23.5843 26.8415 23.5843 25.9087 23.5843 24.0432Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0431 17.575L21.1181 17.575L21.1181 17.5L21.1172 14.7859C21.1172 14.7859 21.1172 14.7859 21.1172 14.7859C21.1172 13.7787 20.6795 12.8142 19.9029 12.1042C19.1282 11.3958 18.3023 10.9966 16.9797 10.9966L14.587 10.9964L16.3757 9.36107L16.4364 9.30552L16.3755 9.25018L15.488 8.44447L15.4374 8.39854L15.387 8.44465L11.9495 11.5875L11.8889 11.6429L11.9495 11.6982L15.387 14.8411L15.4376 14.8873L15.4882 14.8411L16.3694 14.0354L16.4299 13.9801L16.3695 13.9247L14.5865 12.2893L17.3212 12.2893C17.8647 12.2893 18.4645 12.5642 18.9297 13.0181C19.3941 13.4711 19.7172 14.0956 19.7172 14.7859L19.7172 14.786L19.7181 17.5L19.7181 17.575L19.7931 17.575L21.0431 17.575Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridArrowFilled);
export default __webpack_public_path__ + "static/media/grid-arrow-filled.541d857fa52893f85a288e60f30f09f9.svg";
export { ForwardRef as ReactComponent };